const sl = {
  // Errors
  errors: {
    unauthorized: 'Neavtoriziran',
    unauthorizedMessage: 'Prosimo prijavite se!',
    ups: 'Napaka',
    pageNotFound: 'Strani ni mogoče najti',
    forbidden: 'Ups! Napaka 403, Dostop do tega predela strani vam je prepovedan',
    mismatch: 'Gesla se ne ujemajo',
    missingInput: 'Prosimo pravilno vstavite manjkajoče podatke: '
  },
  alerts: {
    success: 'Uspešno!',
    error: 'Napaka!',
    results: 'Odgovori izpita niso na voljo, saj izpit še ni bil reševan!'
  },
  header: {
    reports: 'Prijave nalog',
    users: 'Uporabniki',
    tablets: 'Tablice',
    groups: 'Skupine',
    langEng: 'English', // language is not translated
    langSlo: 'Slovenščina', // language is not translated
    exercises: 'Vaje',
    progress: 'Rating',
    leave: 'Skupine',
    classes: 'Razredi',
    exams: 'Izpiti',
    statistics: 'Statistika',
    panel: 'Nadzorna plošča',
    library: 'Knjižnica',
    reportsStart: 'Imate',
    reportsEnd: 'čakajočih prijav nalog',
    reportsView: 'Pokaži vse',
    version: 'Verzija',
    literature: 'Literatura'
  },
  pages: {
    confirmEmail: {
      success: 'Tvoj email je bil uspešno potrjen!',
      fail: 'Tvoj žeton je potekel'
    },
    literature: {
      literature: 'Literatura',
      bannerName: 'Literatura',
      addButton: 'Dodaj gumb',
      studyLiterature: 'Študijska literatura',
      videos: 'Posnetki predavanja',
      buttonAdded: 'Gumb je bil dodan!',
      insertButtonText: 'Vstavi tekst gumba: ',
      insertButtonLink: 'Vstavi povezavo gumba: ',
      storeButton: 'Dodaj nov gumb',
      storeKeyword: 'Dodaj novo besedo',
      keywordStored: 'Beseda je bila dodana!',
      insertKeyword: 'Vstavi besedo: ',
      storeVideoButton: 'Dodaj nov gumb za video',
      storeTextButton: 'Dodaj nov gumb za tekst'
    },
    group: {
      bannerName: 'Skupine',
      bannerName2: 'Tvoje skupine',
      welcomeMessage: 'Več skupin',
      welcomeMessage2: 'Moje skupine',
      welcomeMessage3: 'Arhivirane skupine',
      joinMsg: 'Pridruži se',
      searchMsg: 'Poišči nalogo',
      enter: 'Vstopi',
      leaveGroup: 'Zapusti skupino',
      opensAt: 'Odpre se ob',
      duration: 'Trajanje',
      owner: 'Lastnik',
      enrolled: 'Včlanjen',
      pending: 'Nepotrjen',
      archived: 'Arhivirana',
      await: 'V čakanju na potrditev',
      awaitModalOne: 'Vaš vpis še ni bil potrjen za ta letnik te skupine.',
      awaitModalTwo: 'Prosimo počakajte na potrditev.',
      joinGroup: 'Pridruži se skupini'
    },
    subgroups: {
      dailyExercises: 'Naloge dneva',
      noDaily: 'Ustvari novo nalogo dneva',
      createSubGroup: 'Ustvari podskupino',
      addExercises: 'Dodaj naloge',
      emptyExercises: 'Ta skupina nalog je prazna.',
      exam: 'Izpit',
      coverage: 'Pokritost področja',
      emptySubgroup: 'Ta podskupina je prazna!',
      noQuizzes: 'Ta podskupina nima kvizov.',
      resetExercises: 'Na voljo kmalu: Resetiraj naloge',
      editSubgroup: 'Uredi podskupino',
      reorderSubgroup: 'Spremeni vrstni red nalog',
      editExercises: 'Uredi naloge',
      previewExercises: 'Oglej si naloge',
      literature: 'Literatura',
      examsAndQuizzes: 'Kvizi',
      examsAndQuizzesDescriptionCollapsed: 'Prikaži vse kvize',
      examsAndQuizzesDescriptionNotCollapsed: 'Skrij vse kvize',
      reorder: 'Spremeni vrstni red podskupin',
      selectSubgroups: 'Izberi podskupine',
      startQuiz: 'Začni kviz',
      createQuiz: 'Ustvari kviz',
      generatedQuiz: 'Rating kviz',
      addAll: 'Dodaj vse',
      removeAll: 'Odstrani vse',
      selectDuration: 'Izberi trajanje',
      createQuizForOtherUsers: 'Ustvari kviz za druge uporabnike',
      editRules: {
        addRule: 'Dodaj pravilo',
        deleteRuleModal: 'Brisanje pravila',
        confirmDeleteMessage: 'Ali ste prepričani, da želite izbrisati to pravilo?',
        deleteConfirm: 'Izbriši',
        deleteCancel: 'Prekliči',
        editRule: 'Uredi pravilo',
        editRules: 'Uredi pravila',
        thereAreNoRules: 'Ta podskupina še nima pravil.',
        identifier: 'Identifikator',
        title: 'Naslov',
        author: 'Avtor',
        source: 'Vir',
        tags: 'Oznake',
        tagFilter: 'Veznik za oznake',
        excludedTags: 'Izključene oznake',
        languages: 'Jeziki',
        type: 'Tip',
        isOwner: 'Lastnik',
        isPublic: 'Javno',
        isTrue: 'Da',
        isFalse: 'Ne'
      },
      importStructure: 'Uvozi strukturo',
      uploadSentence: 'Za nalaganje povleci YAML datoteko',
      uploadSentence2: 'ali klikni tu',
      uploading: 'Nalaganje...',
      successMsg: 'Struktura skupine uspešno ustvarjena',
      errorMsg: 'Pri ustvarjanju strukture skupine je prišlo do napake!',
      exportGroup: 'Izvozi skupino',
      recomputeGroup: 'Osveži skupino',
      pleaseWait: 'Prosimo počakajte',
      subgroup: 'Podskupina',
      numberOfExercises: 'Število nalog',
      yamlError: 'Napaka med YAML uvozom.',
      recomputeError: 'Napaka med rekalkulacijo skupin.',
      yamlSuccess: 'YAML uvoz uspešno zaključen.',
      recomputeSuccess: 'Rekalkulacija skupin uspešno zaključena.',
      yamlProgress: 'Podskupine se generirajo.',
      recomputeProgress: 'Naloge se dodajajo.',
      progress: 'Napredek',
      showExercises: 'Prikaži naloge v podskupini'
    },
    exams: {
      finish: 'Oddaj',
      areYouSure: 'Ali res želiš zaključiti ?',
      timeLeft: 'Preostali čas',
      minutes: 'minut',
      seconds: 'sekund',
      timeForThisExercise: 'Čas te naloge',
      timeForExam: 'Čas celotnega izpita',
      nextExerciseIn: 'Naslednja naloga čez',
      continueNextExercise: 'Preskoči na naslednjo nalogo zdaj',
      oneExerciseAtATimeWarning: 'V tem kvizu je zahtevano reševanje ene naloge naenkrat. Po napredovanju na naslednjo nalogo vrnitev ni mogoča.',
      examinationInfo: 'Podatki o preverjanju',
      allowedAttempts: 'Dovoljeno število poizkusov',
      thisAttemptNumber: 'Zaporedno število tega poizkusa',
      endOfExam: 'Izpit je končan.',
      exercisesList: 'Seznam nalog',
      question: 'Vprašanje',
      answered: 'odgovorjeno',
      notAnswered: 'ni odgovorjeno',
      noLimit: 'Neomejeno',
      remaining: 'preostalih',
      start: 'Začetek',
      finishTime: 'Konec',
      begin: 'Prični',
      createExam: 'Ustvari izpit',
      name: 'Ime',
      examNotScheduled: 'Izpit nima določenega termina',
      goToEditExam: 'Uredi izpit',
      published: 'Objavljen',
      seatingPosition: 'Oznaka stola',
      showAttempts: 'Prikaži oddano',
      currentStatistics: {
        ExerciseName: 'Naloga: ',
        nextExercise: 'Naprej',
        lastExercise: 'Nazaj',
        answer: 'ODG: '
      },
      attemptHistory: {
        attempt: 'Poskus',
        startedAt: 'Začetek',
        finishedAt: 'Konec',
        status: 'Status',
        grade: 'Točke',
        unavailable: 'Ni na voljo',
        finished: 'Končan',
        inProgress: 'V teku',
        showAttempt: 'Prikaži poskus',
        examName: 'Ime izpita',
        allExams: 'Vsi izpiti'
      },
      editExam: {
        editExam: 'Uredi izpit',
        refreshExercises: 'Pridobi zadnje verzije nalog',
        updated: 'Uspešno posodobljeno',
        unpublishWarning: 'Za urejanje izpita ne sme biti objavljenih terminov',
        exam: 'Izpit',
        quiz: 'Kviz',
        selectType: 'Izberi tip',
        maxRetries: 'Izberi število ponavljanj',
        oneAtATime: 'Ena naloga naenkrat',
        shuffle: 'Premešaj naloge',
        enabled: 'Da',
        disabled: 'Ne',
        noLimit: 'Neomejeno',
        exercises: 'Naloge',
        tableData: 'Data ID',
        tableTags: 'Značke',
        tablePos: 'Pribitek',
        tableNeg: 'Odbitek',
        tableAllow: 'Dovoli odbitek',
        classExams: 'Termini',
        tableClass: 'Razred',
        classRoom: 'Predavalnica',
        addClassroom: 'Dodaj predavalnico',
        manageClassrooms: 'Urejaj predavalnice',
        wingsNumber: 'Število kril v predavalici: ',
        apply: 'Potrdi',
        insertRowsForEachWing: 'Vnesite število vrstic v posameznem krilu',
        wing: 'Krilo',
        row: 'Vrsta',
        setSeats: 'Nastavite število sedežev za vsako vrsto',
        validClassroom: 'Predavalnica uspešno narejena. Prosimo, vnesite še ime: ',
        selectSeat: 'Označite svoj sedež v predavalnici',
        tablePass: 'Geslo',
        tableDateTime: 'Datum in čas',
        tableDuration: 'Trajanje',
        passwordNotSet: 'Ni nastavljeno',
        timeMinutes: 'minute',
        timeHours: 'ure',
        timeDays: 'dnevi',
        publish: 'Objavi',
        unpublish: 'Prekliči objavo',
        save: 'Shrani in zapri',
        tablePoints: 'Točke',
        tableTime: 'Čas naloge [s]',
        question: 'Vprašanje',
        allowed: 'Odbitek',
        notAllowed: 'Ni odbitka',
        displayResults: 'Prikaz rezultatov',
        showResults: 'Prikaži rezultate',
        hideResults: 'Skrij rezultate',
        copyExercises: 'Skopiraj naloge',
        ratingExercises: 'Rating naloge',
        fromGroup: 'Iz skupine',
        addExercises: 'Dodaj Naloge',
        versions: 'verzij',
        exerciseVersions: 'Vse verzije naloge',
        collapseParametric: 'Združi parametrične',
        expandParametric: 'Razdruži parametrične',
        modals: {
          changePassword: 'Spremeni geslo',
          noPassword: 'Če termin ne potrebuje gesla, pusti polje prazno.',
          update: 'Posodobi',
          searchExercises: 'Išči naloge',
          cancel: 'Prekliči',
          add: 'Dodaj naloge',
          deleteTitle: 'Ali ste prepričani, da želite izbrisati ta izpit?',
          deleteConfirm: 'Izbriši',
          deleteCancel: 'Prekliči',
          updateTitle: 'Ste prepričani?',
          updateBody: 'Posodabitev nalog bo izbrisala vse dosedanje odgovore študentov?',
          confirmFetchLatest: 'Potrdi posodabljanje nalog'
        }
      },
      classrooms: {
        addClassroom: 'Dodaj predavalnico',
        classroomID: 'ID',
        classroomName: 'Classroom name',
        showSketch: 'Show sketch',
        delete: 'Delete',
        successfullySeated: 'Izbrani sedež je prost. Kliknite gumb, če želite začeti s kvizom',
        showExecGroups: 'Prikaži skupine nalog',
        hideExecGroups: 'Skrij skupine nalog',
        showSeatMarks: 'Pokaži oznake sedežev',
        manageClassrooms: 'Predavalnice',
        allClassroomsList: 'Seznam vseh predavalnic',
        colorGroup: 'Pobarvaj skupino',
        customizeGroups: 'Prilagodi barve',
        selectColorSeats: 'Izberite stole za pobarvati',
        customizeColoring: 'Prilagodi pobarvane sedeže',
        turnOffCustomizeColoring: 'Izklopi ročno barvanje',
        selectColors: 'Izberite barvo',
        selectedSeats: 'Pobarvani stoli',
        turnOnGroupEditor: 'Vklopi urejevalnik skupin',
        groupEditorTurnedOn: 'UREJEVALNIK SKUPIN JE VKLJUCEN',
        turnOffGroupEditor: 'Izklopi urejevalnik skupin',
        selectGroup: 'Izberite skupino, ki bi jo dodelili'
      },
      ratingResults: {
        ratingExamResults: 'Rezultati rating kviza',
        achievvedPoints: 'Dosežene točke',
        possiblePoints: 'Možne točke',
        percent: 'Odstotek',
        rating: 'Rating',
        ratingChange: 'Sprememba ratinga',
        ratingAccuracy: 'Natančnost ratinga',
        highAccuracy: 'Visoka natančnost',
        mediumHighAccuracy: 'Srednja natančnost',
        mediumLowAccuracy: 'Srednja natančnost',
        lowAccuracy: 'Zelo nizka natančnost',
        viewYourAnswers: 'Poglej svoje odgovore',
        ratingHistory: 'Zgodovina ratinga',
        completeMoreQuizes: 'Za uvrstitev na lestvico morate rešiti več kvizov',
        yourRatingIsInaccurate: 'Natančnost vašega ratinga mora biti vsaj',
        leaderboard: 'Lestvica',
        joinedLeaderboard: 'Uspešno ste se uvrstili na lestvico!',
        improveRating: 'Za višje rezultate rešite več kvizov',
        numberOfSolvedExercises: 'Pravilno rešene naloge',
        leaderboardEmpty: 'Nihče se še ni uvrstil na lestvico',
        infoTitle: 'Rating uporabnikov in nalog',
        info: 'Ko rešite Rating kviz, se glede na vaše rezultate izračuna vaš rating in rating nalog, ki ste jih reševali na kvizu.',
        infoDeviation: 'Rating sistem v eQuiz-u upošteva tudi natančnost vašega ratinga, ki je na začetku majhna, saj je rating izračunan na majhni količini podatkov. Ko rešite več kvizov, bo vaš rating bolj natančen. ' +
                       'Za uvrstitev na lestvico, mora biti vaš rating vsaj 75% natančen. ' +
                       'Če ne rešite nobenega kviza, se skozi čas natančnost vašega ratinga počasi manjša.',
        ratingQuizInfo: 'V rating kvizu boste reševali naključno izbrane naloge iz izbranih podskupin. ' +
                        'Na podlagi vaših rezultatov bo izračunan vaš nov rating in rating nalog, ki jih boste reševali. Rešitve in ratinge nalog lahko pogledate po končanem kvizu.'
      }
    },
    home: {
      helloRegister: 'Še nimate računa?'
    },
    login: {
      username: 'Uporabniško ime',
      password: 'Geslo',
      remeberMe: 'Zapomni si me',
      login: 'Prijava',
      loginSMsg: 'Prijava uspešna!',
      forgotPassword: 'Ste pozabili geslo?',
      google: 'Prijava z Google računom'
    },
    register: {
      email: 'Elektronski naslov',
      username: 'Uporabniško ime',
      name: 'Ime',
      surname: 'Priimek',
      studentId: 'Vpisna številka',
      password: 'Geslo',
      register: 'Registracija',
      registerSMsg: 'Registracija uspešna! Prosimo, preverite vašo e-pošto da registracijo potrdite! Ne pozabite preveriti še "spam" mape!',
      passwordRetype: 'Ponovno vnesite geslo',
      addNew: 'Dodaj novega uporabnika',
      addButton: 'Dodaj',
      newUserRole: 'Vloga',
      mismatch: 'Gesla se ne ujemajo',
      recap: 'Dokažite, da niste robot!',
      ssoMissingData: 'Vnesite mankajoče podatke',
      ssoMissingDataSubmit: 'Oddaj',
      ssoMissingDataLogOut: 'Odjava',
      ssoMissingDataEmpty: 'Polje je prazno',
      ssoMissingDataStudentIdInvalid: 'Vpisna številka ni pravilna',
      alreadyHaveAnAccount: 'Že imate račun?',
      emailSent: 'Potrdite elektronski naslov',
      emailSentSuccess: 'Registracija uspešna! Prosimo, preverite vašo e-pošto, da registracijo potrdite! Ne pozabite preveriti še „spam” mape!'
    },
    resetPassword: {
      title: 'Pozabljeno geslo',
      email: 'Elektronski naslov',
      resetMsg: 'Ponastavi geslo',
      successMsg: 'Potrditveni mail poslan.',
      back: 'Nazaj na prijavo',
      description: 'Vnesite elektronski naslov na katerega vam bomo poslali navodila za ponastavitev gesla.'
    },
    setPassword: {
      msg: 'Preden začneš uporabljati E-quiz si moraš najprej nastaviti geslo',
      password: 'Geslo',
      retypePassword: 'Ponovi geslo',
      confirmButtonMsg: 'Nastavi',
      successMsg: 'Geslo uspešno ponastavljeno'
    },
    setNewPassword: {
      msg: 'Nastavi si novo geslo',
      password: 'Novo geslo',
      retypePassword: 'Ponovi geslo',
      confirmButtonMsg: 'Nastavi'
    },
    exercise: {
      examClearExercise: 'Počisti',
      finish: 'Zaključi',
      evaluateExam: 'Oddaj',
      evaluated: 'Uspešno oddano',
      evaluateEssay: 'Oddaj',
      evaluateText: 'Preveri',
      hintText: 'Namig',
      solvedText: 'Rešitev',
      correctMsg: 'Uspeh!',
      wrongMsg: 'Neuspeh!',
      previous: 'Nazaj',
      next: 'Naprej',
      report: 'Prijavi',
      name: 'Naloga',
      info: 'Informacije o nalogi',
      point1: 'točka',
      point2: 'točki',
      point3: 'točke',
      point5: 'točk',
      points: 'Točke',
      pointsNotAvailable: 'Točke niso na voljo',
      doNotExist: 'ne obstaja',
      onDelete: 'Naloga uspešno zbrisana',
      modalInfoId: 'ime naloge',
      modalInfoAuthor: 'avtor',
      modalInfoTags: 'oznake',
      modalInfoSource: 'vir',
      submitEssay: 'Oddano',
      submitExam: 'Oddano',
      back: 'Nazaj',
      rating: 'Rating naloge',
      answers: {
        correct: 'Odgovor je pravilen',
        incorrect: 'Odgovor ni pravilen.',
        partiallyCorrect: 'Odgovor je delno pravilen.',
        correctAnswer: {
          singular: 'Pravilen odgovor je',
          dual: 'Pravilna odgovora sta',
          plural: 'Pravilni odgovori so'
        },
        noAnswer: 'To vprašanje se ne ocenjuje avtomatsko',
        noSolution: 'Za to vprašanje ni celotne rešitve',
        parametricSolution: 'Ta naloga je parametrična, spodaj sta besedilo in rešitev za nadrejeno nalogo',
        parametricSolution2: 'Ta naloga je parametrična, spodaj je rešitev za nadrejeno nalogo'
      }
    },
    createGroup: {
      prompt: 'Izberi ime nove skupine',
      name: 'Ime',
      description: 'Opis',
      coverUrl: 'URL naslovnice',
      createButton: 'Ustvari',
      createGroupSMsg: 'Skupina uspešno ustvarjena!',
      public: 'Javna',
      visibility: 'Vidna',
      dynamic: 'Dinamična'
    },
    userIconInHeader: {
      pleaseLogin: 'Prosim prijavi se',
      profile: 'Profil',
      signOut: 'Odjava',
      notLoggedInUsername: 'Gost',
      changeLanguange: 'Spremeni jezik'
    },
    profile: {
      prompt: 'Uporabniški profil',
      name: 'Ime',
      surname: 'Priimek',
      studentId: 'Vpisna številka',
      email: 'Elektronski naslov',
      username: 'Uporabniško ime',
      edit: 'Uredi profil',
      save: 'Shrani',
      generalInfo: 'Splošno',
      phName: 'Vpiši ime',
      phSurname: 'Vpiši priimek',
      phEmail: 'Vpiši email',
      phStudentId: 'Vpiši vpisno številko',
      langSlo: 'Slovenščina', // language is not translated
      langEng: 'English', // language is not translated
      lang: 'Jezik',
      adminAdmit: 'Administratorju dovolim pregled mojih rezultatov',
      cancel: 'Prekliči',
      update: 'Posodobi',
      student: 'Študent',
      userData: 'Osebni podatki',
      avgGrade: 'Povprečna uspešnost',
      grade: 'Ocena',
      userpicture: {
        userPicture: 'Slika uporabnika',
        loadPicture: 'Za nalaganje povleci sliko',
        loadPicture2: 'ali klikni na to polje',
        load: 'Naloži sliko',
        uploading: 'Nalagam sliko ...',
        success: 'Profilna slika uspešno posodobljena',
        errorMsg: 'Pri nalaganju slike je prišlo do napake, prosim preveri tip datoteke!',
        change: 'Spremeni sliko',
        delete: 'Odstrani sliko'
      },
      changepassword: {
        userPassword: 'Spremeni geslo',
        oldPass: 'Staro geslo',
        newPass: 'Novo geslo',
        change: 'Spremeni geslo',
        repeatNewPass: 'Ponovi geslo',
        phOldPass: 'Vpiši staro geslo',
        phNewPass: 'Vpiši novo geslo',
        noMatch: 'Gesli se ne ujemata',
        success: 'Uspešno posodobljeno geslo'
      },
      changeroles: {
        changeRole: 'Spremeni vlogo',
        changeRoleButton: 'Spremeni'
      }
    },
    language: {
      locale: 'jezik'
    },
    reports: {
      reported: 'Prijave',
      comment: 'Komentar',
      status: 'Stanje',
      edit: 'Uredi',
      comparePending: 'v čakanju',
      compareIgnored: 'prezrt',
      compareResolved: 'rešen',
      exerciseReports: 'Prijave nalog',
      report: 'Prijavi nalogo',
      close: 'Zapri',
      save: 'Shrani',
      reportSuccessful: 'Prijava uspešna',
      reportsOnExec: 'Vse prijave na nalogo ',
      reportUserId: 'ID Uporabnika',
      reportDescription: 'Besedilo prijave',
      reportStatus: 'Stanje prijave',
      reportReact: 'Razreši',
      noReportsFound: 'Za to nalogo ni podanih prijav'
    },
    exerciseList: {
      exercises: 'Upravljanje nalog',
      list: 'Seznam nalog',
      tableId: 'Id',
      tableDataId: 'Data id',
      tableTags: 'Oznake',
      tableAuthor: 'Avtor',
      tableSource: 'Vir',
      tableCreatedAt: 'Ustvarjena',
      tableUpdatedAt: 'Posodobljena',
      tableTitle: 'Naslov',
      success: 'Uspešno dodano',
      nmPerPage: 'Število prikazanih nalog',
      showAll: 'Prikaži vse',
      selectGr: 'Izberi skupino',
      selectSgr: 'Izberi podskupino',
      footSentence: {
        senOne: 'Prikazanih',
        senTwo: 'od',
        senThree: 'nalog'
      },
      page: 'Stran',
      library: 'Knjižnica',
      import: 'Uvozi naloge',
      addNew: 'Dodaj novo nalogo',
      importRating: 'Uvozi/Izvozi rating',
      importTitle: 'Uvozi',
      exportTitle: 'Izvozi',
      downloadCSV: 'Naloži csv',
      uploadRatingSuccess: 'Uspešno naložena datoteka z ratingom.',
      uploadRatingError: 'Pri nalaganju datoteke je prišlo do težave.',
      dragToUpload: 'CSV datoteko povleči sem.',
      uploading: 'Nalaganje.',
      upload: 'Naloži',
      uploadPictures: 'Naloži slike',
      uploadSuccess: 'Slike uspešno naložene',
      uploadErrorMsg: 'Pri nalaganju slik je prišlo do napake, prosim preveri tip datotek!',
      hide: 'Skrij',
      startWith: 'Se začne s/z',
      contains: 'Vsebuje',
      showAdvanced: 'Prikaži napredno iskanje',
      hideAdvanced: 'Skrij napredno iskanje',
      owner: 'Lastnik',
      public: 'Javne',
      search: 'Išči',
      reset: 'Resetiraj filtre',
      importButton: 'Uvozi .tex',
      addExerciseButton: 'Dodaj nalogo',
      addTags: 'Dodaj oznake, ločene s vejico',
      showHideSub: 'Skrij/pokaži podnaloge',
      addSubExec: 'Dodaj podnalogo',
      showBasicInfo: 'Pokaži osnovne informacije',
      hideBasicInfo: 'Skrij osnovne informacije',
      currentSubExecCnt: 'Trenutno število podnalog: ',
      execPreText: 'Dodaj navodila / opis naloge: ',
      chooseNewExecInputMethod: 'Izberite željeno metodo za vnos novih nalog',
      inputMethodLatex: 'S formatom LaTeX',
      inputMethodInterface: 'Preko vmesnika',
      inputMethodBober: 'Bober',
      latexSave: 'Shrani in vnesi',
      execInputAnswer: 'Vnesite odgovor: ',
      execInputPrecision: 'Zahtevana natančnost odgovora: ',
      execAddHint: 'Po želji dodajte namig: ',
      finishExec: 'Zaključi in dodaj v knjižnico',
      finishSubExec: 'Zaključi in dodaj podnalogo',
      latexSuccessfullyImported: 'Uspešno vnešene naloge',
      radioAddAnswer: 'Dodaj odgovor',
      radioAddAnswerIfCorrect: 'Pravilno? ',
      cancel: 'Prekliči',
      radioMultipleCorrect: 'Samo en odgovor je lahko pravilen',
      answersSoFar: 'Vsi odgovori do sedaj',
      inputBasicExecInfo: 'Vnesite osnovne informacije o nalogi',
      addToSubgroup: 'Dodaj v podskupino',
      add: 'Dodaj',
      chooseExecType: 'Izberite tip naloge (odgovor)',
      typeNumerical: 'Numerical (število)',
      typeRadio: 'Radio (da / ne)',
      typeEssay: 'Essay (vnos odgovora)',
      typeMultichoice: 'Multichoice (izberi)',
      typeLikert: 'Likert (skala)',
      execTypeQuestion: 'Vnesite vprašanje: ',
      updated: 'Uspešno posodobljeno',
      deleted: 'Uspešno izbrisano',
      statement: 'Trditev',
      of: 'od',
      next: 'Naprej',
      previous: 'Nazaj',
      placeholders: {
        dataId: 'Išči po knjižnici nalog',
        title: 'Išči po naslovu',
        author: 'Išči po avtorju',
        source: 'Išči po viru',
        tags: 'Značke',
        tagsExclude: 'Izpusti značke',
        languages: 'Jeziki',
        types: 'Tipi'
      }
    },
    preview: 'Predogled naloge',
    editexercise: {
      prompt: 'Uredi nalogo',
      uploadNew: 'Naloži novo nalogo',
      title: 'Ime naloge',
      description: 'Navodilo naloge'
    },
    ratingHistory: {
      currentRating: 'Trenutni rating',
      bestRating: 'Najboljši rating',
      worstRating: 'Najslabši rating',
      ratingHistory: 'Zgodovina ratinga kvizov',
      numberOfPoints: 'Število točk',
      date: 'Datum',
      rating: 'Rating',
      startQuiz: 'Začni kviz',
      ratingQuiz: 'Rating kviz',
      graph: 'Graf kvizov'
    },
    buttons: {
      add: 'Dodaj',
      create: 'Ustvari',
      save: 'Shrani',
      edit: 'Uredi',
      delete: 'Izbriši',
      update: 'Posodobi',
      success: 'Uspešno',
      fail: 'Napaka',
      updated: 'Posodobljeno',
      confirm: 'Potrdi',
      deleteP: 'Želite nadaljevati? Izgubili boste vse vsebujoče podskupine, izpite in značke napredka.',
      search: 'Išči',
      showAll: 'Prikaži vse',
      cancel: 'Prekliči',
      goToUserProfile: 'Pojdi na uporabniški profil',
      details: 'Podrobnosti',
      back: 'Nazaj',
      refresh: 'Osveži'
    },
    requiredField: {
      enterPrompt: 'Zahtevana polja',
      firstName: 'Ime',
      lastName: 'Priimek',
      studentId: 'Vpisna številka',
      allowUseOfMyResults: 'Dovoli uporabo rezultatov',
      username: 'Uporabniško ime',
      email: 'Email',
      emailVerifiedAt: 'Email potrjen dne',
      password: 'Geslo',
      profilePictureUrl: 'Slika profila'
    },
    adminpanel: {
      statistics: {
        group: 'Statistika',
        show: 'Prikaži',
        registered: 'Število registriranih uporabnikov',
        active: 'Število aktivnih uporabnikov',
        exC: 'Pravilnih',
        ecW: 'Napačnih'
      },
      ratingStatistics: {
        bannerName: 'Rating',
        group: 'Statistika ratinga v skupini',
        userRatings: 'Histogram študentskih ratingov',
        numberOfStudents: 'Število študentov',
        exerciseRatings: 'Histogram ratingov nalog',
        numberOfExercises: 'Število nalog',
        ratingExamsInLastWeek: 'Rating kvizov v zadnjem tednu',
        averageRatingChange: 'Sprememba ratingov v zadnjem tedenu',
        exportUserRatingsCSV: 'Izvozi CSV datoteko z ratingom študenotv',
        downloadAllUsers: 'Naloži rating vseh študentov',
        name: 'Ime',
        downloadSingleClass: 'Naloži samo en razred:',
        userRatingStatistics: 'Rating statistika uporabnikov',
        studentId: 'Vpisna št.',
        numberOfRatingTests: 'Število rating testov',
        currentRating: 'Trenutni rating',
        showMore: 'Prikaži več',
        hiddenStatistics: 'Uporabnik je skril rezultate',
        studentRatings: 'Ratingi študentov'
      },
      createdailychallenge: {
        editName: 'Ime',
        isActive: 'Aktivna',
        create: 'Ustvari',
        save: 'Shrani',
        dateRange: 'Od/do',
        result: 'Prikaži rezultat',
        exercise: 'Ime naloge',
        findExercise: 'Začni pisati, da pričneš z iskanjem nalog',
        successDelete: 'Dnevna naloga uspešno zbrisana!'
      },
      users: {
        listOfUsers: 'Seznam uporabnikov',
        search: 'Išči',
        tableId: 'Id',
        tableUser: 'Uporabnik',
        tableDate: 'Datum',
        tableRole: 'Vloge',
        bannerName: 'Uporabniki',
        manageUsersButton: 'Upravljaj uporabnike',
        nmOfUsersPrompt: 'Vpisanih uporabnikov',
        userActivity: 'Aktivnost',
        createGroup: 'Dodaj novo skupino'
      },
      classes: {
        bannerName: 'Razredi',
        manageClassesButton: 'Upravljaj razrede',
        awaiting: 'Čakajoči na potrditev',
        tableId: 'Id',
        tableUser: 'Uporabnik',
        tableDate: 'Datum',
        tableStudentId: 'Vpisna številka',
        confirm: 'Potrdi',
        move: 'Premakni',
        createClass: 'Ustvari nov razred',
        deleteClass: 'Izbrisi razred',
        confirmation: 'Potrdite izbris tega razreda',
        toDefault: 'Vsi študenti razreda bodo premaknjeni v privzeti razred.',
        cancel: 'Prekliči',
        deleteEnrollment: 'Izbriši vpis',
        confirmation2: 'Potrdite izbris vpisanega študenta',
        autoEnrollDisable: 'Onemogoči samodejni vpis',
        autoEnrollEnable: 'Izberi razred za samodejni vpis',
        defaultClass: 'Razred za samodejni vpis',
        exportUserRatingForClass: 'Rating tega razreda',
        exportUserRatingForGroup: 'Rating celotne skupine'
      },
      group: {
        createPrompt: 'Ustvari skupino',
        groupPrompt: 'Skupina',
        createGroupPrompt: 'Ustvari skupino',
        public: 'Javna',
        editGroup: 'Uredi skupino',
        editYear: 'Uredi leto',
        createYear: 'Ustvari novo leto',
        archiveGroup: 'Arhiviraj leto',
        editId: 'Id',
        editName: 'Ime',
        editDescription: 'Opis',
        editCover: 'URL naslovnice',
        save: 'Shrani',
        color: 'Barva'
      },
      subgroup: {
        nmOfSubgroupsPrompt: 'Podskupine',
        editSubgroup: 'Uredi podskupino',
        editName: 'Ime',
        editDescription: 'Opis',
        visibility: 'Vidna',
        save: 'shrani',
        editVideoLink: 'Youtube',
        editVideoTime: 'Začetek Videoposnetka (mm:ss)'
      },
      exercises: {
        bannerName: 'Naloge',
        manageExercisesButton: 'Upravljaj skupine nalog',
        loadExercise: 'Za nalaganje povleci nalogo',
        loadExercise2: 'ali klikni na to polje',
        successMsg: 'Naloge uspešno naložene',
        errorMsg: 'Prišlo je do napake pri nalaganju',
        uploading: 'Nalagam naloge ...'
      },
      tablets: {
        bannerName: 'Tablice',
        manageExamsButton: 'Upravljaj tablice',
        nmOfExamsPrompt: 'Kvizi in izpiti',
        listOfAnnouncedDevices: 'Seznam zaznanih naprav',
        identifier: 'Id',
        deviceName: 'Ime naprave',
        created: 'Ustvarjena',
        updated: 'Čas zadnje aktivnosti',
        search: 'Išči',
        register: 'Registriraj napravo',
        name: 'Ime',
        group: 'Skupina',
        comment: 'Komentar',
        password: 'Geslo',
        modalApproveYes: 'Registriraj',
        modalApproveNo: 'Zapri',
        edit: 'Uredi napravo',
        modalApproveYesEdit: 'Shrani',
        modalApproveNoEdit: 'Prekliči',
        alertSuccess: 'Shranjeno',
        registered: 'Registrirana',
        listOfAllDevices: 'Seznam naprav',
        delete: 'Zbriši napravo',
        modalDeleteYes: 'Potrdi',
        generateOtp: 'Ustvari enkratno geslo'
      },
      year: {
        yearPrompt: 'Leto',
        editId: 'Id',
        editName: 'Ime',
        editRequiredFields: 'Zahtevana polja',
        name: 'Leto',
        visibility: 'Vidno',
        archived: 'Arhivirano',
        save: 'Shrani',
        createYear: 'Prosim usvari novo leto'
      }
    },
    gradebook: {
      title: 'Redovalnica',
      search: 'Išči',
      name: 'Ime'
    }
  }
}

export default sl



// WEBPACK FOOTER //
// ./src/lang/sl.js